import { Injectable } from '@angular/core';
import { PhotographerDashboardResume } from '../models/new/photographerDashboardResume';
import { ShotResume } from '../models/new/shotResume';

@Injectable({
	providedIn: 'root'
})
export class ResumeMapper {
	toShotResume(shot: any) {
		return new ShotResume({
			requiredShots: shot.requiredShots,
			approvedShots: shot.approvedShots,
			rejectedShots: shot.rejectedShots,
			uploadedShots: shot.uploadedShots,
			missingShots: shot.missingShots,
			totalSku: shot.totalSku,
			//estimatedCost: shot.estimatedCost,
			finalCost: shot.finalCost
		});
	}

	toPhotographerDashboardResume(data: any) {
		return new PhotographerDashboardResume({
			draft: data?.draft?.totalCount || 0,
			readyForPickup: data?.readyForPickup?.totalCount || 0,
			inProgress: data?.inProgress?.totalCount || 0,
			shootCompleted: data?.shootCompleted?.totalCount || 0,
			approved: data?.approved?.totalCount || 0,
			rejected: data?.rejected?.totalCount || 0
		});
	}
}
